import { useEffect, useState } from "react";
import { pageIndicator } from "../apollo";
import { AsideAdminComponent } from "../layout/aside-admin";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ComponentTabLink,
  ITabLink,
  ITabTitle,
  PageType,
} from "../components/component-tab";
import { Link } from "react-router-dom";
import exit from "../assets/icon/exit.png";
import { Modal } from "@mui/material";

import React from "react";
import { useListInquiry } from "../hooks/useListInquiry";
import moment from "moment";
import { useDelInquiry } from "../hooks/useDelInquiry";
import { TableError } from "../components/table-error";
import { PaginationComponent } from "../components/pagination";
import { useEditInquiryStatus } from "../hooks/useEditInquiryStatus";
import {
  InquiryStatus,
  EditInquiryStatusInput,
  ListInquiryInput,
  DelInquiryInput,
  EditInquiryStatusMutation,
  DelInquiryMutation,
} from "../generated/graphql";
import { ListCouponInput, useListCoupon } from "../hooks/useListCoupon";
import { CouponScopeEnum } from "../constants/enum";

export interface ISearchFormProps {
  search: string;
}

export const AdminListCoupon = () => {
  const location = useLocation();
  const [open, setOpen] = React.useState(false);
  const [page, setPage] = useState<number>(1);
  const [search, setSearch] = useState<string>("");
  const [value, setValue] = React.useState("확인중");
  const [stateId, setStateId] = useState<number>(0);
  const [change, setChange] = useState<InquiryStatus>(InquiryStatus.New);
  const navigate = useNavigate();
  const tabList: ITabLink[] = [];
  const stitle: ITabTitle = {
    text: "쿠폰 관리",
  };
  const word = "쿠폰";

  const [listCoupon, { data, loading, refetch }] = useListCoupon();
  console.log(data);
  const listCouponHandler = (
    page: number,
    search: string,
    start?: string,
    end?: string
  ) => {
    const input: ListCouponInput = {
      page: page,
      search: search,
      start: start,
      end: end,
    };
    listCoupon({ variables: { input } });
  };

  // --- Search ---
  const setSearchHandler = (search: string) => {
    navigate({
      pathname: "/coupon",
      search: `${search ? `?search=${search}` : ""}`,
    });
    listCouponHandler(1, search);
  };

  // --- Page ---
  const pageHandler = (page: number) => {
    const search =
      location.search.split("search=").length > 1
        ? location.search.split("search=")[1].split("&")[0]
        : null;
    setPage(page);
    navigate({
      pathname: "/coupon",
      search: `?page=${page}${search ? `&search=${search}` : ""}`,
    });
    listCouponHandler(page, search || "");
  };

  useEffect(() => {
    pageIndicator("coupon");
    setPage(
      location.search.split("page=").length > 1
        ? +location.search.split("page=")[1].split("&")[0]
        : 1
    );
    setSearch(
      location.search.split("search=").length > 1
        ? location.search.split("search=")[1].split("&")[0]
        : ""
    );
    listCouponHandler(page, search);
  }, [search, page]);

  return (
    <div className="bg-main bg-opacity-50 w-full h-full min-h-screen">
      <div className="w-full mx-auto h-full min-h-screen  bg-gray-100">
        <main id="main">
          <div className="grid grid-cols-[200px_1fr] max-w-full">
            <AsideAdminComponent />
            <div className="mypages bg-gray-100 w-full min-w-[1200px] overflow-hidden">
              <div className="orderWrap">
                <div className="  h-fix-content relative">
                  <div className={`w-full h-full px-10 py-8`}>
                    <ComponentTabLink
                      tabs={tabList}
                      stitle={stitle}
                      setSearchs={setSearchHandler}
                      setDateSearch={() => {}}
                      type={PageType.Coupon}
                    />
                    {/* 여기 */}
                    <div className="shadow-lg h-[800px] h-fix-content w-full overflow-auto bg-white">
                      <table className="align-center min-w-[1160px] 2xl:min-w-[1623px] text-[14px] ">
                        <colgroup>
                          <col width="48"></col>
                          <col></col>
                          <col width="128"></col>
                          <col width="128"></col>
                          <col width=""></col>
                          <col width="80"></col>
                          <col width="256"></col>
                          <col width="80"></col>
                        </colgroup>
                        <thead>
                          <tr className=" border-b border-[#F9F8F9] h-8">
                            <th className="text-[#8B8C8C]">no</th>
                            <th className="text-[#8B8C8C] text-left pl-2">
                              이름
                            </th>
                            <th className="text-[#8B8C8C]">할인 금액</th>
                            <th className="text-[#8B8C8C]">발행 단위</th>
                            <th className="text-[#8B8C8C]">사용처</th>
                            <th className="text-[#8B8C8C]">발행매수</th>
                            <th className="text-[#8B8C8C]">사용 기한</th>
                            <th className="text-[#8B8C8C]">비고</th>
                          </tr>
                        </thead>
                        <tbody className="dataField">
                          {data?.listCoupon.coupons.map((coupon, index) => (
                            <tr
                              key={`coupons-${coupon.id}-${index}`}
                              className="border-b border-[#F9F8F9] h-[68px]"
                            >
                              <td className="table-text">{index + 1}</td>
                              <td className="text-left pl-2">{coupon.name}</td>
                              <td className="table-text">
                                {coupon.discountPrice} 원
                              </td>
                              <td className="table-text">
                                {coupon.scope === CouponScopeEnum.LINK_SERVICE
                                  ? "서비스 지역"
                                  : "매장"}
                              </td>
                              <td className="table-text">
                                {coupon.scope === CouponScopeEnum.LINK_SERVICE
                                  ? coupon.linkService?.name
                                  : coupon.corporation?.name}
                              </td>
                              <td className="table-text">
                                {coupon.usageLimit === 0
                                  ? "제한 없음"
                                  : `${coupon.usageLimit}개`}
                              </td>
                              <td className="table-text">
                                {moment(coupon.validFrom).format("YYYY-MM-DD")}{" "}
                                ~{" "}
                                {moment(coupon.validUntil).format("YYYY-MM-DD")}
                              </td>
                              <td className="table-text">
                                <button
                                  className="bg-[#CCCCCC] rounded-lg py-[6px]  w-[48px] h-7 text-white"
                                  onClick={() => {
                                    navigate(`/coupon/${coupon.id}/edit`);
                                  }}
                                >
                                  편집
                                </button>
                              </td>
                            </tr>
                          ))}
                          {data?.listCoupon.coupons.length === 0 && (
                            <tr>
                              <td colSpan={8} className="text-center">
                                쿠폰 정보가 없습니다.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      {loading && (
                        <TableError errorMessage={`정보를 불러오는중입니다`} />
                      )}
                      {!loading &&
                        data?.listCoupon.coupons &&
                        data.listCoupon.coupons.length < 1 && (
                          <TableError
                            errorMessage={`${word} 정보가 없습니다`}
                          />
                        )}

                      {!loading &&
                        data?.listCoupon.coupons &&
                        data.listCoupon.coupons.length > 0 && (
                          <PaginationComponent
                            page={page}
                            totalPages={Number(data.listCoupon.totalPages)}
                            totalResults={Number(data.listCoupon.totalResults)}
                            pageHandler={pageHandler}
                          />
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};
